import { observer } from 'mobx-react';
import { T } from '../../../../../../Translations';
import TriangleExclamationIcon from '../../../../../Cutesies/TriangleExclamationIcon';
import ImportParticipantsStore from '../../../Store';
import { ImportedParticipants } from '../../../Store/Types';
import DownloadCSV from '../../Body/DownloadCSV';
import ViewReport from '../../Body/ViewReport';
import ImportMessage from '../Shared/ImportMessage';
import StatusMessage from '../Shared/StatusMessage';
import ViewAndDownloadCSV from '../Shared/ViewAndDownloadCSV';
import { CheckIcon } from '@execonline-inc/execonline-ui';

interface Props {
  totalCount: number;
  store: ImportParticipantsStore;
  importedParticipants: ImportedParticipants;
}

function AlertImport({ totalCount, store, importedParticipants }: Props) {
  const partialParticipants = [
    ...importedParticipants.successfulParticipants,
    ...importedParticipants.formattingIssue,
    ...importedParticipants.participantsOfDifferentOrg,
    ...importedParticipants.participantsOfSameOrg,
    ...importedParticipants.failedParticipants,
  ];

  return (
    <div className="flex flex-col items-center">
      <StatusMessage
        icon={<TriangleExclamationIcon width="160" height="160" />}
        messageKey="Import Partially Successful"
      />
      <T
        kind="You attempted to import {{totalCount}} participants but only {{successCount}} could be imported successfully"
        successCount={importedParticipants.successfulParticipants.length}
        totalCount={totalCount}
      />
      <ViewAndDownloadCSV store={store} downloadData={partialParticipants} view="full-view" />
      <hr className="border-t border-[#D9D9D9] w-4/5 my-4 h-1" />
      <p className="flex items-center justify-center text-sm mt-2 font-semibold">
        <CheckIcon size="md" color="green" />
        <T
          kind="Successfully Imported ..."
          span={(content) => <span className="ml-2">{content}</span>}
          successfulCount={importedParticipants.successfulParticipants.length}
          viewImport={<ViewReport store={store} status="success-view" text="View all details" />}
          downloadCSV={<DownloadCSV downloadData={importedParticipants.successfulParticipants} />}
        />
      </p>
      <ImportMessage
        store={store}
        importedParticipants={importedParticipants}
        icon={<TriangleExclamationIcon width="24" height="24" />}
      />
      <hr className="border-t border-[#D9D9D9] w-4/5 my-4 h-1" />
    </div>
  );
}

export default observer(AlertImport);
